import React, {useState, useEffect} from 'react';
import MetaTags from 'react-meta-tags';  // Added Meta Tag npm Package
import { Row, Col, Card, CardBody, CardTitle, Modal, Form, Container, Button, Alert, UncontrolledTooltip, Table, UncontrolledDropdown, DropdownToggle, DropdownMenu } from "reactstrap";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

import { Link, useHistory, useParams } from "react-router-dom"
 import "flatpickr/dist/themes/material_blue.css";
import Flatpickr from "react-flatpickr";

import axios from 'axios';
import { HRConfig, TOAST_OPTIONS, formatDate, downloadBase64File } from "../../helpers/backend_helper"
import * as url from 'helpers/url_helper';
import { TIMESHEETSAPPROVALS, TIMESHEETS } from 'helpers/url_helper';

import toastr, { error } from "toastr";
import "toastr/build/toastr.min.css";

import LoadingOverlay from 'react-loading-overlay';
import ClimbingBoxLoader from 'react-spinners/ClimbingBoxLoader'

    const ViewSubmittedTimesheet = () => {

        const history = useHistory();
        const {approvalEntryNo} = useParams();

        const [lR, setLR] = useState({})
        const [empNo, setEmpNo] = useState('');
        const [empName, setEmpName] = useState('');
        const [empTitle, setEmpTitle] = useState('');
        const [gender, setGender] = useState('');
        const [leaveNo, setLeaveNo] = useState('');
        const [leaveCategory, setLeaveCategory] = useState('');
        const [tsStatus, settsStatus] = useState('');
        const [st, setSt] = useState('danger');
        const [hrManagerName, setHRManagerName] = useState('');
        const [departmentCode, setDepartmentCode] = useState('');
        const [postingDate, setPostingDate] = useState('');
        const [isloading, setIsloading] = useState(false);
        const [userError, setUserError] = useState(true);

        const [CompanyID, setCompanyID] = useState("")
        const [showApproveBtn, setShowApproveBtn] = useState(true);
        const [showRejectBtn, setShowRejectBtn] = useState(false);
        const [comment, setComment] = useState('')

        const [modal_line, setmodal_line] = useState(false)
        const [lineSystemID, setLineSystemId] = useState('')
        const [isEdit, setIsEdit] = useState(false)
        const [entryNo, setEntryno] = useState('')
        const [sequenceNo, setSequenceNo] = useState('')
        const [dateTimeSentForApproval, setDatetimesentforApproval] = useState('')
        const [month, setMonth] = useState('')
        const [dueDate, setDueDate] = useState('')
        const [periodRange, setPeriodRange] = useState('')

        const [approvals, setApprovals] = useState([])
        const [timesheetLines, setTimesheetlines] = useState([])

        toastr.options = TOAST_OPTIONS;
        const [inputs, setInputs] = useState([]);
        const handleChange = (event) => {
             const name = event.target.name;
             const value = event.target.value;
             setInputs(values => ({...values, [name]: value}));
        }
        const removeBodyCss = () => {
            document.body.classList.add("no_padding");
        }
        const tog_line = () => {
            setmodal_line(!modal_line);
            removeBodyCss();
        }
        const handleSubmit = (event) => {
            event.preventDefault();
            toastr.success("Leave Request No  created" ); 
        }
        
        const handleActionChange = () =>{
            const selectedAction = document.getElementsByClassName('lAction')[0].value;
                if(selectedAction == 'APPROVE'){
                    setShowApproveBtn(true)
                    setShowRejectBtn(false)
                }else if(selectedAction == 'REJECT'){
                    setShowApproveBtn(false)
                    setShowRejectBtn(true)
                }
        }
        const handleRejectTS = () =>{
            setIsloading(true)
            const lNo = {"no": approvalEntryNo}
            axios.post(url.REJECTTIMESHEET+'?company='+CompanyID, JSON.stringify(lNo), HRConfig)
                .then(function(response){ 
                    if(response.status == '200'){
                        toastr.info("Timesheet request rejected");
                        history.push(`/timesheet-approvals`) 
                    }else{
                        toastr.error("Could not reject timesheet" )
                    }
                    setIsloading(false)
                })
                .catch(function (error) {
                    console.log(error)
                    setIsloading(false)
            })  
        }
        const handleReopenTS = () =>{
            setIsloading(true)
            const lNo = {"no": approvalEntryNo}
            axios.post(url.REOPENTIMESHEET+'?company='+CompanyID, JSON.stringify(lNo), HRConfig)
                .then(function(response){ 
                    if(response.status == '200'){
                        toastr.info("Timesheet request reopened");
                        history.push(`/my-timesheets`) 
                    }else{
                        toastr.error("Could not Reopen timesheet" )
                    }
                    setIsloading(false)
                })
                .catch(function (error) {
                    console.log(error)
                    setIsloading(false)
            })  
        }
        const handleApproveTS = () =>{
            setIsloading(true)
            const lNo = {"no": approvalEntryNo}
            axios.post(url.APPROVETIMESHEET+'?company='+CompanyID, JSON.stringify(lNo), HRConfig)
                .then(function(response){ 
                    if(response.status == '200'){
                        toastr.info("Timesheet request Approved");
                        history.push(`/timesheet-approvals`) 
                    }else{
                        toastr.error("Could not approve timesheet" )
                    }
                    setIsloading(false)
                })
                .catch(function (error) {
                    console.log(error)
                    setIsloading(false)
            })  
        }
        const handleUpdateLine2 = () =>{
            setIsloading(true)
            const Config = {
                auth: {
                  username: url.HRMIS,
                  password: url.HRMISPASS,
                },
                headers: {
                  'Content-Type': 'application/json',
                  'If-Match'    : '*'
                }
            }
            const data = {
              comment : comment
              
            }
            axios.patch(`${url.TIMESHEETS}(${lineSystemID})?company=${CompanyID}`, JSON.stringify(data), Config).then(function(response){
                if(response.request.status == '200'){
                    toastr.success("Timesheet line comment updated successfully" ); 
                    tog_line(false)
                    fetchData()
                }else{
                    toastr.error("Could not update timesheet line comment!!" )
                }
                setIsloading(false)
            }).catch(function (error){
                console.log(error)
                toastr.error(error.response.data.error.message);
                setIsloading(false)
            })
        }
        const handleApproveLR = () =>{
            setIsloading(true)
            const lNo = {'no': leaveNo}
            axios.post(url.APPROVE_LR +'?company='+CompanyID, JSON.stringify(lNo), HRConfig)
                .then(function(response){     
                    if(response.status == '200'){
                        toastr.success("Leave request Approved" );
                        history.push(`/leave-approvals`) 
                    }else{
                        toastr.error("Could not Approve leave request" )
                    }
                    setIsloading(false)
                })
                .catch(function (error) {
                    toastr.error(error.response.data.error.message);
                    setIsloading(false)
                })
        }

        const handleEditLine = (k) =>{
            const p = timesheetLines[k]
            console.log(timesheetLines[k])
            setIsEdit(true)
            setLineSystemId(p.SystemId)
            console.log(p.SystemId)
            tog_line()
        }
   
        const fetchData = () =>{
            let obj = JSON.parse(localStorage.getItem("authMildUser"));
            let EmployeeNo = obj.uid;
            setCompanyID(obj.activeCompany);
            setIsloading(true) 
            axios.get(`${TIMESHEETSAPPROVALS}?$filter=approvalEntryNo eq ${approvalEntryNo} and status eq 'Created' &company='${obj.activeCompany}'`, HRConfig)
                .then(function(response){
                    setApprovals(response.data.value)
                    setEmpNo(response.data.value[0].employeeNo)
                    setEmpName(response.data.value[0].employeeName)
                    setDepartmentCode(response.data.value[0].department)
                    setEntryno(response.data.value[0].entryNo)
                    console.log(response.data.value[0].entryNo)
                    setSequenceNo(response.data.value[0].sequenceNo)
                    setDatetimesentforApproval(response.data.value[0].dateTimeSentForApproval)
                    setMonth(response.data.value[0].month)
                    setDueDate(response.data.value[0].dueDate)
                    setPeriodRange(response.data.value[0].periodRange)
                    settsStatus(response.data.value[0].status)
                    setIsloading(false)
                }).catch((e)=>{
                setIsloading(false)
                console.log(e)
            })   
            axios.get(`${TIMESHEETS}?$filter=aPIApprovalRequestNo eq ${approvalEntryNo} and status eq 'Submitted' &company='${obj.activeCompany}'`, HRConfig)
                .then(function(response){ 
                    setTimesheetlines(response.data.value)
                }).catch((e) => {
                console.log(e)
            })  
        }
        useEffect(() => {
            fetchData()
        },[]);
        
        return (
            <>
            <LoadingOverlay
                active={isloading}
                spinner={<ClimbingBoxLoader />}
                text='Please wait...'
                >
                <div className="page-content">
                    <MetaTags>
                    <title>Timesheet Request Details | {url.APPNAME}</title>
                    </MetaTags>
                    <Container fluid={true}>
                        <Breadcrumbs title={`Human Resources Management`} breadcrumbItem={`Timesheet Request Details`} />
                        <Form onSubmit={handleSubmit}>
                    
                            <Alert color={`${st}`} role="alert">
                                    <strong>{tsStatus}</strong>
                            </Alert>
           
                        <Row>
                        <Col xl={4}>
                        <Card>
                            <CardBody>
                                <CardTitle>Employee Details</CardTitle>
                                    <div className="table-responsive">
                                        <table className="table">
                                            <tbody>
                                                <tr>
                                                    <th scope="col"> Number</th>
                                                    <td scope="col"> {empNo} </td>
                                                </tr>
                                                <tr>
                                                    <th scope="col"> Name</th>
                                                    <td scope="col">{empName}</td>
                                                </tr>
                                                <tr>
                                                    <th scope="col">Position</th>
                                                    <td scope="col">{empTitle}</td>
                                                </tr>
                                                <tr>
                                                    <th scope="row">Department Code</th>
                                                    <td>{departmentCode}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </CardBody>
                            </Card>
                            </Col>
                            <Col  xl={8}>
                            <Card>
                                <CardBody>
                                    <CardTitle className="mb-3">
                                        Timesheet Approval Entry Details
                                    </CardTitle>
                                    <div className="table-responsive">
                                        <Row>
                                            <Col md={5}>
                                                <table className="table">
                                                    <tbody>
                                                        <tr>
                                                            <th scope="col"> Approval Entry No.</th>
                                                            <td scope="col"> {approvalEntryNo} </td>
                                                        </tr>
                                                        <tr>
                                                            <th scope="col"> Sequence No.</th>
                                                            <td scope="col">{sequenceNo}</td>
                                                        </tr>
                                                        <tr>
                                                            <th scope="col">Entry No.</th>
                                                            <td scope="col">{entryNo}</td>
                                                        </tr>
                                                        <tr>
                                                            <th scope="col">Status</th>
                                                            <td>{tsStatus}</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </Col>
                                            <Col md={7}>
                                                <table className="table">
                                                    <tbody>
                                                        <tr>
                                                            <th scope="col"> Month</th>
                                                            <td scope="col"> {month} </td>
                                                        </tr>
                                                        <tr>
                                                            <th scope="col"> Due Date</th>
                                                            <td scope="col">{dueDate}</td>
                                                        </tr>
                                                        <tr>
                                                            <th scope="col">Datetime sent for Approval</th>
                                                            <td scope="col">{dateTimeSentForApproval}</td>
                                                        </tr>
                                                        <tr>
                                                            <th scope="col">Period Range</th>
                                                            <td scope="col">{periodRange}</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </Col>
                                        </Row>
                                    </div>
                                </CardBody>
                            </Card>
                            <Card>    
                                <Modal isOpen={modal_line} toggle={() => { tog_line(); }}  size="l" centered  backdrop={'static'}  >
                                    <div className="modal-header">
                                        <h5 className="modal-title mt-0" id="myModalLabel">{isEdit?`Update/Delete `:`Add ` }Timesheet line Comment</h5>
                                        <button type="button"  onClick={() => { setmodal_line(false) }}  className="close" data-dismiss="modal"aria-label="Close">
                                            <span aria-hidden="true">&times;</span>
                                        </button>
                                    </div>
                                    <div className="modal-body">
                                        <Row>
                                            <Col lg={12}>
                                                <label htmlFor="floatingSelectGrid">Comment</label>
                                                    <div className="form-floating mb-3">
                                                        <input  type="text" className="form-control" value={comment} onChange={(e)=>setComment(e.target.value)}   />
                                                    </div>
                                            </Col>        
                                            <div className="hstack gap-2">
                                                <button className="btn btn-success btn-block w-100" onClick={handleUpdateLine2}><i className="mdi mdi-content-save"/>{" "}Save comment</button>
                                            </div>
                                        </Row>
                                    </div>
                                </Modal>  
                            </Card>            
                        </Col>
                        <Card>
                            <CardBody>
                                <CardTitle className= "mb-3 mt-1 justify-content-center">
                                    Timesheet Request Lines ({timesheetLines.length})
                                </CardTitle>
                                <CardBody className="border-bottom">
                                    {(tsStatus == 'Created') ? (
                                        <div className="table-responsive">
                                            <Table  className="table table-striped table-sm mb-4">
                                                <thead>
                                                    <tr>
                                                        <th style={{ verticalAlign: 'middle', textAlign: 'center' }}>Week Start Date</th>
                                                        <th style={{ verticalAlign: 'middle', textAlign: 'center' }}>Week End Date</th>
                                                        <th style={{ verticalAlign: 'middle', textAlign: 'center' }}>Hours</th>
                                                        <th style={{ verticalAlign: 'middle', textAlign: 'center' }}>Working Day</th>
                                                        <th style={{ verticalAlign: 'middle', textAlign: 'center' }}>Leave Type</th>
                                                        <th style={{ verticalAlign: 'middle', textAlign: 'center' }}>Description</th>
                                                        <th style={{ verticalAlign: 'middle', textAlign: 'center' }}>Fund Source</th>
                                                        <th style={{ verticalAlign: 'middle', textAlign: 'center' }}>Comment</th>
                                                        <th style={{ verticalAlign: 'middle', textAlign: 'center' }}></th>     
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                {timesheetLines.map((a,k)=>(
                                                    <tr key={k}>
                                                        <td style={{ verticalAlign: 'middle', textAlign: 'center' }}>{a.weekStartDate}</td>
                                                        <td style={{ verticalAlign: 'middle', textAlign: 'center' }}>{a.weekEndDate}</td>
                                                        <td style={{ verticalAlign: 'middle', textAlign: 'center' }}>{a.hours}</td>
                                                        <td style={{ verticalAlign: 'middle', textAlign: 'center' }}>{a.workingDay}</td>
                                                        <td style={{ verticalAlign: 'middle', textAlign: 'center' }}>{a.leaveType}</td>
                                                        <td style={{ verticalAlign: 'middle', textAlign: 'center' }}>{a.description}</td> 
                                                        <td style={{ verticalAlign: 'middle', textAlign: 'center' }}>{a.dimensionValueCode1}</td>
                                                        <td style={{ verticalAlign: 'middle', textAlign: 'center' }}>{a.comment}</td> 
                                                        <td style={{ verticalAlign: 'middle', textAlign: 'center' }}> 

                                                        {/* <div className="d-flex gap-3"> 
                                                            <Link
                                                                to="#"
                                                                className="text-primary"
                                                                onClick={() =>{handleEditLine(k)}}
                                                            >
                                                            <i className="mdi mdi-pencil font-size-18" id="edittooltip" />
                                                                <UncontrolledTooltip placement="top" target="edittooltip">
                                                                    Update Comment
                                                                </UncontrolledTooltip>
                                                            </Link>   
                                                        </div> */}
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </Table>
                                    </div>
                                    ):(
                                        <div className="text-center">
                                            <div className="mb-4">
                                                <i className="mdi mdi-calendar-clock text-warning display-4" />
                                            </div>
                                            <div>
                                                <h5>No Timesheet Request Lines added, yet!</h5>
                                            </div>
                                        </div>
                                    )}
                                </CardBody>
                            </CardBody>  
                        </Card>
                        <div className="d-flex">
                            <div className="flex-grow-1 ms-1">                                 
                                <ul className="list-unstyled vstack gap-2 mb-0">
                                    <div className="d-grid gap-2">
                                    {/* <Col md={12}>
                                            <div className="mb-3">
                                            <label htmlFor="floatingSelectGrid"> Select Action</label>
                                                <select  className="form-select lAction" onChange={handleActionChange}>  
                                                    <option value="APPROVE">APPROVE TIMESHEET REQUEST</option>
                                                    <option value="REJECT">REJECT TIMESHEET REQUEST</option>
                                                </select>    
                                            </div>
                                        </Col> */}
                                        <Col md={12} className="reject">
                                            <div className="d-grid gap-2">
                                                <Button color="danger" type="button" className="btn btnRejectRequest" onClick={handleReopenTS}>
                                                    <i className="mdi mdi-cancel"/>{" "}
                                                        Reopen Timesheet Request
                                                </Button>
                                            </div>
                                        </Col>
                                        {/* {showRejectBtn && (
                                            <div className="form-floating mb-3">
                                                <input  type="text" className="form-control" onChange={(e)=>setComment(e.target.value)}  />
                                                <label htmlFor="floatingSelectGrid"> Rejection Comment</label>
                                            </div>
                                        )} */}
                                        {/* {showRejectBtn && (
                                        <Col md={12} className="reject">
                                            <div className="d-grid gap-2">
                                                <Button color="danger" type="button" className="btn btnRejectRequest" onClick={handleRejectTS}>
                                                    <i className="mdi mdi-cancel"/>{" "}
                                                        Reject Timesheet Request
                                                </Button>
                                            </div>
                                        </Col>
                                        )}
                                        {showApproveBtn && (
                                        <Col md={12} className="approve">
                                            <div className="d-grid gap-2">
                                                <Button color="primary" type="button" className="btn btnApproveRequest" onClick={handleApproveTS}>
                                                    <i className="mdi mdi-check-circle-outline text-success"/>{" "}
                                                        Approve Timesheet Request
                                                </Button>
                                            </div>
                                        </Col>
                                        )} */}
                                    </div>
                                </ul>
                            </div>
                        </div>
                    </Row>
                </Form>
            </Container>
        </div>
    </LoadingOverlay>
    </>
)};

export default ViewSubmittedTimesheet;